import { useRegisterSW } from 'virtual:pwa-register/vue'

export default defineNuxtPlugin(() => {
  const { updateServiceWorker } = useRegisterSW({
    immediate: true, // registra subito il nuovo SW
    onNeedRefresh() {
      // forza l'update del service worker appena disponibile
      updateServiceWorker(true)
    },
    onOfflineReady() {
    },
  })
})
